module.exports = __webpack_public_path__ + "static/audi-0cab9f7551edf2ad68688a561761895d.png";